import React, { memo, useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { useTranslation } from "react-i18next";
import { isMobile } from "react-device-detect";

import AutoSizer from "react-virtualized-auto-sizer";

import StockDetail from "./stock-components/StockDetail";
import StockPriceChart from "./stock-components/StockPriceChart";
import StockHist from "./stock-components/StockHist";
import StockStatistic from "./stock-components/StockStatistic";
import StockCandleStickIndayChart from "./stock-components/StockCandleStickIndayChart";
import CandleStickHistChart from "./share-components/CandleStickHistChart";

import IndustryTop from "./industry-components/IndustryTop";
import IndustryIndexDetail from "./industry-components/IndustryIndexDetail";

import IDXPopupContent from "./index-components/IDXPopupContent";

import SideTabStockSuggest from "./ItemTabSidebar/SideTabStockSuggest";

import { priceToNumber, signNumber, formatNumber, formatDateGMT7 } from "../helpers/utils";
import { hidePopupInfo } from "../redux/actions/sharedActions";

import { constHostAddressConfig } from "../helpers/constData";
import { showPopupInfo, addFavSymbol, removeFavSymbol } from "../redux/actions/sharedActions";

// ------------------- TTDN -------------------
import HoSo from "../components/ttdn-components/HoSo";
//import CoDong from '../components/ttdn-components/CoDong'
import CoTuc from "../components/ttdn-components/CoTuc";
import TaiChinh from "../components/ttdn-components/TaiChinh";
// ------------------- TTDN -------------------
import Draggable, { DraggableData, DraggableEvent } from "react-draggable";
import _ from "lodash";
import { StockGeneralV2 } from "./ItemTabSidebar/TabInfo";
import StockMatchDetail from "./stock-components/StockMatchDetail";
import StockMatchDetailV2 from "./stock-components/StockMatchDetailV2";
import IndustryIndexDetailViewTable from "./industry-components/IndustryIndexDetailViewTable";
import MDDetailChart from "./index-components/MDDetailChart";
import IndustryIndexNormalViewTable from "./industry-components/IndustryIndexNormalViewTable";
import { useAxios } from "../helpers/apiHelper";
import StockCharBarDetail from "./stock-components/StockCharBarDetail";
import { getOverflowOptions } from "antd/es/_util/placements";

export default function PopupInfo() {
   const refPopupContainer = useRef(null);

   const { t } = useTranslation();
   const dispatch = useDispatch();
   const popupConfig = useSelector((state) => state.gShared.popupConfig);
   const language = useSelector((state) => state.gShared.language);

   const stockInfo = useSelector((state) => state.gSymbol.symbolInfos.find((item) => item.code === popupConfig.code)) ?? {};

   // console.log(stockInfoTPRL, "stockInfoTPRL", popupConfig.code);

   const s_counter = useSelector((state) => state.gSymbol.symbolInfos.find((item) => item.code === popupConfig.code)?.counter);

   const indexInfo = useSelector((state) => state.gIndex.indexInfos.find((item) => item.indexCode === popupConfig.code)) ?? {};
   const i_counter = useSelector((state) => state.gIndex.indexInfos.find((item) => item.indexCode === popupConfig.code)?.counter);
   const userName = useSelector((state) => state.gUser.userName ?? "");

   const { priceBoardFavSymbols, priceBoardFavSymbolsLength } = useSelector(
      (state) => ({
         priceBoardFavSymbols: state.gShared.priceBoardFavSymbols,
         priceBoardFavSymbolsLength: state.gShared.priceBoardFavSymbols?.length ?? 0,
      }),
      (prev, next) => {
         return prev.priceBoardFavSymbolsLength === next.priceBoardFavSymbolsLength;
      }
   );

   const groupSymbol = useSelector((state) =>
      state.gShared.industries.find((e) => (popupConfig.type === "ST" && e.symbolList.indexOf(popupConfig.code) >= 0) || (popupConfig.type === "IND" && e.code === popupConfig.code))
   );

   const [chartType, setChartType] = useState("D");
   const [showSearchSuggest, setShowSearchSuggest] = useState(false);
   const [position, setPosition] = useState({ x: null, y: null });
   //
   const handleDrag = (e, ui) => {
      const { x, y } = ui;
      setPosition({ x, y });
   };

   const _handleChangeChartType = (type) => {
      setChartType(type);
   };
   const _onMessageReceived = (message) => {
      const _msgsource = message.data["source"];
      if (_msgsource === "tradingviewembedded") {
         const type = message.data.payload.type === "Index" ? "IDX" : message.data.payload.type === "Stock" ? "ST" : "";

         if (type && type !== "") {
            showPopupInfo(dispatch, type, message.data.payload.symbol);
         }
      }
   };

   const _handleChangeSearchSuggest = () => {
      if (showSearchSuggest) {
         setShowSearchSuggest(false);
      } else {
         setShowSearchSuggest(true);
      }
   };

   const _handleSearchSuggestSelected = (value, type) => {
      setShowSearchSuggest(false);
      if (value && value !== "" && type && type !== "") {
         showPopupInfo(dispatch, type, value);
      }
   };

   const _handleClickOutsidePopup = (event) => {
      if (refPopupContainer && refPopupContainer.current === event.target) {
         handleClosePopup();
      }
   };
   const handleClosePopup = () => {
      hidePopupInfo(dispatch);
      setPosition({ x: null, y: null });
   };
   //
   useEffect(() => {
      window.addEventListener("message", _onMessageReceived, false);
      return () => {
         window.removeEventListener("message", _onMessageReceived, false);
      };
   }, []);

   useEffect(() => {
      if (!popupConfig.show && chartType !== "D") {
         setChartType("D");
      }
   });

   const c_refPrice = priceToNumber(stockInfo.refPrice ?? "") * 1000;
   const c_ceilPrice = priceToNumber(stockInfo.ceilPrice ?? "") * 1000;
   const c_floorPrice = priceToNumber(stockInfo.floorPrice ?? "") * 1000;
   const [tabActiveShareHolder, setTabActiveShareHolder] = useState(0);

   const useCompanyProfile = useSelector((state) => state.gShared.useCompanyProfile);

   const axios = useAxios();

   const [inforBasic, setInforBasic] = useState([]);
   const [lstEvents, setLstEvents] = useState([]);

   useEffect(() => {
      if (stockInfo.code && stockInfo.code !== "") {
         getListInforNormal();
         getListEvent();
      }
   }, [stockInfo.code]);

   const getListInforNormal = async () => {
      const formData = new FormData();
      formData.append("symbol", stockInfo.code);

      try {
         const res = await axios.post(`info-basic`, formData);

         if (res && res.status === 200 && res.data.success) {
            setInforBasic(JSON.parse(res.data.json)[0]);
         } else {
         }
      } catch (error) {
         console.log(error);
      }
   };

   const getListEvent = async () => {
      const formData = new FormData();
      formData.append("symbol", stockInfo.code);

      try {
         const res = await axios.post(`rss?symbol=${stockInfo.code}`);

         if (res && res.status === 200 && res.data.success) {
            setLstEvents(JSON.parse(res.data.json));
         } else {
         }
      } catch (error) {
         console.log(error);
      }
   };

   return popupConfig.show ? (
      <div ref={refPopupContainer} className="popup-container" onClick={_handleClickOutsidePopup}>
         <Draggable onDrag={handleDrag} position={position} handle=".popup__header">
            <div className="popup">
               <div
                  className="popup__header"
                  onClick={() => {
                     isMobile && handleClosePopup();
                  }}
               >
                  {popupConfig.type === "ST" ? (
                     <>
                        <div className="d-flex">
                           {showSearchSuggest ? (
                              <div style={{ position: "relative" }}>
                                 <SideTabStockSuggest isShow={showSearchSuggest} onSelectedValue={_handleSearchSuggestSelected} />
                              </div>
                           ) : (
                              <>
                                 {(stockInfo.code ?? "") +
                                    (stockInfo.referenceStatus && stockInfo.referenceStatus !== "" && stockInfo.referenceStatus !== "0" ? "*" : "") +
                                    " -  " +
                                    (stockInfo.symbolName ?? "") +
                                    " -  " +
                                    (stockInfo.marketName ?? "")}
                              </>
                           )}
                        </div>
                        <div className="popup__header--right">
                           <button
                              type="button"
                              onClick={() => {
                                 handleClosePopup();
                              }}
                           >
                              <img src="/static/img/icon/icon-close.svg" alt="img" />
                           </button>
                        </div>
                     </>
                  ) : popupConfig.type === "IND" ? (
                     <>
                        <div className="">{groupSymbol ? t("codeIndustry_" + groupSymbol.code) : indexInfo.indexName}</div>
                        <div className="popup__header--right">
                           <div></div>
                           <button
                              type="button"
                              onClick={() => {
                                 handleClosePopup();
                              }}
                           >
                              <img src="/static/img/icon/icon-close.svg" alt="img" />
                           </button>
                        </div>
                     </>
                  ) : (
                     <>
                        <div className="d-flex" style={{ alignItems: "center", justifyContent: "start" }}>
                           {/* <button className="btn-change-stock ml-2" title={t("thayDoiMaCKCS")} onClick={_handleChangeSearchSuggest}>
                              <img src="/static/img/icon/icon-search-btn.svg" alt="img" />
                           </button> */}
                           {showSearchSuggest ? (
                              <div
                                 style={{
                                    position: "relative",
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    fontWeight: 600,
                                    fontSize: 14,
                                    padding: "2px 6px",
                                    color: "#fff",
                                    transition: "all 0.2s ease",
                                    borderRadius: 8,
                                    background: "#2c2c2e",
                                    border: "1px solid #444",
                                    gap: "4px",
                                    width: 336,
                                    marginTop: "4px",
                                 }}
                              >
                                 <img src="/static/img/icon/icon-search-btn.svg" alt="img" />
                                 <SideTabStockSuggest isShow={showSearchSuggest} onSelectedValue={_handleSearchSuggestSelected} />
                              </div>
                           ) : (
                              <div
                                 onClick={_handleChangeSearchSuggest}
                                 style={{
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    fontWeight: 600,
                                    fontSize: 14,
                                    padding: "2px 6px",
                                    color: "#fff",
                                    transition: "all 0.2s ease",
                                    borderRadius: 8,
                                    background: "#2c2c2e",
                                    border: "1px solid #444",
                                    gap: "4px",
                                    width: 336,
                                    marginTop: "4px",
                                 }}
                              >
                                 <img src="/static/img/icon/icon-search-btn.svg" alt="img" />
                                 {indexInfo.indexName}
                              </div>
                           )}
                           {/* <button className="btn-change-stock ml-2" title={t("thayDoiMaCKCS")} onClick={_handleChangeSearchSuggest}>
                              <img src="/static/img/icon/icon-search-btn.svg" alt="img" />
                           </button> */}
                        </div>
                        <div className="popup__header--right">
                           <div className={indexInfo.currentIndex_color}>
                              {formatNumber(indexInfo.currentIndex)}{" "}
                              <span>
                                 {signNumber(indexInfo.changeIndex)} / {signNumber(indexInfo.pctChangeIndex)}%
                              </span>
                           </div>
                           <button
                              type="button"
                              onClick={() => {
                                 handleClosePopup();
                              }}
                              onTouchStart={() => {
                                 handleClosePopup();
                              }}
                           >
                              <img src="/static/img/icon/icon-close.svg" alt="img" />
                           </button>
                        </div>
                     </>
                  )}
               </div>
               <div className="body__modal popup__background-color">
                  <div className="popup__content popup__body">
                     {popupConfig.type === "ST" ? (
                        <Tabs style={{ display: "flex", flexDirection: "column" }}>
                           <TabList className="mb-1">
                              <Tab>{t("tongQuan")}</Tab>
                              <Tab>{t("coBan")}</Tab>
                              <a href={`https://ifin.tvsi.com.vn/${stockInfo.code}`} target="_blank" rel="noopener noreferrer">
                                 {t("chiTiet")}
                              </a>
                           </TabList>
                           <TabPanel style={{ flex: 1 }}>
                              <IndustryIndexDetailViewTable industryCode={groupSymbol?.code} groupSymbol={groupSymbol} />

                              {isMobile ? (
                                 <AutoSizer>
                                    {({ height, width }) => {
                                       return (
                                          <div style={{ height: height, width: width }}>
                                             <div className="scroll-styled">
                                                <div>
                                                   {chartType !== "D" ? (
                                                      <CandleStickHistChart code={stockInfo.code} type="ST" chartType={chartType} style={{ height: "250px" }} />
                                                   ) : (
                                                      <StockCandleStickIndayChart code={stockInfo.code} style={{ height: "250px" }} />
                                                   )}
                                                </div>
                                                <div className={"text-center listoption"} style={{ paddingTop: 10, paddingBottom: 20 }}>
                                                   <button className={chartType === "D" ? "active" : ""} onClick={() => _handleChangeChartType("D")} onTouchStart={() => _handleChangeChartType("D")}>
                                                      {t("homNay")}
                                                   </button>
                                                   <button className={chartType === "W" ? "active" : ""} onClick={() => _handleChangeChartType("W")} onTouchStart={() => _handleChangeChartType("W")}>
                                                      1 {t("tuan")}
                                                   </button>
                                                   <button
                                                      className={chartType === "1M" ? "active" : ""}
                                                      onClick={() => _handleChangeChartType("1M")}
                                                      onTouchStart={() => _handleChangeChartType("1M")}
                                                   >
                                                      1 {t("thang")}
                                                   </button>
                                                   {/* <button
                                    className={chartType === "3M" ? "active" : ""}
                                    onClick={() => _handleChangeChartType("3M")}
                                    onTouchStart={() => _handleChangeChartType("3M")}
                                  >
                                    3 {t("thang")}
                                  </button>
                                  <button
                                    className={chartType === "6M" ? "active" : ""}
                                    onClick={() => _handleChangeChartType("6M")}
                                    onTouchStart={() => _handleChangeChartType("6M")}
                                  >
                                    6 {t("thang")}
                                  </button>
                                  <button
                                    className={chartType === "1Y" ? "active" : ""}
                                    onClick={() => _handleChangeChartType("1Y")}
                                    onTouchStart={() => _handleChangeChartType("1Y")}
                                  >
                                    1 {t("nam")}
                                  </button>
                                  <button
                                    className={chartType === "5Y" ? "active" : ""}
                                    onClick={() => _handleChangeChartType("5Y")}
                                    onTouchStart={() => _handleChangeChartType("5Y")}
                                  >
                                    5 {t("nam")}
                                  </button> */}
                                                </div>

                                                <StockDetail counter={stockInfo.counter} code={stockInfo.code} stockInfo={stockInfo} />
                                                <div className="titletabs">{t("mucGia")}</div>
                                                <StockPriceChart style={{ height: "200px" }} code={stockInfo.code} floorPrice={c_floorPrice} refPrice={c_refPrice} ceilPrice={c_ceilPrice} />
                                             </div>
                                          </div>
                                       );
                                    }}
                                 </AutoSizer>
                              ) : (
                                 <div
                                    style={{
                                       display: "flex",
                                       height: "calc(100% - 90px)",
                                       width: "100%",
                                       position: "relative",
                                       gap: "15px",
                                    }}
                                 >
                                    <div style={{ height: "100%", display: "flex", flexDirection: "column", flex: 1 }}>
                                       <iframe
                                          style={{ height: "100%", width: "100%", border: "unset" }}
                                          src={constHostAddressConfig.ApiTVSIAddress + "chart?" + `symbol=${stockInfo.code}&language=${language}&p_username=${userName}`}
                                          title=""
                                       ></iframe>
                                    </div>
                                    <div className="boxinfo--right" style={{ width: "40%" }}>
                                       <Tabs>
                                          <TabList className="mb-1">
                                             <Tab>{t("lichSuKL")}</Tab>
                                             <Tab>{t("suKien")}</Tab>
                                             <Tab>{t("bieuDoKhopLenhTheoBuocGia")}</Tab>
                                          </TabList>
                                          <TabPanel>
                                             <AutoSizer>
                                                {({ height, width }) => {
                                                   return (
                                                      <div className="tbl__popup" style={{ height: height, width: width }}>
                                                         <div className="tab-body-right d-flex flex-column" style={{ height: height }}>
                                                            <StockMatchDetailV2
                                                               style={{ height: "100%", flex: 1 }}
                                                               code={stockInfo.code}
                                                               refPrice={stockInfo.refPrice}
                                                               floorPrice={stockInfo.floorPrice}
                                                               ceilPrice={stockInfo.ceilPrice}
                                                            />
                                                         </div>
                                                      </div>
                                                   );
                                                }}
                                             </AutoSizer>
                                          </TabPanel>
                                          <TabPanel>
                                             <div className="scrollTable tabs-content">
                                                <table className="tb-popup-detail">
                                                   <thead>
                                                      <tr>
                                                         <th>Sự kiện</th>
                                                         <th>Chi tiết</th>
                                                      </tr>
                                                   </thead>
                                                   <tbody>
                                                      {lstEvents &&
                                                         lstEvents.length > 0 &&
                                                         lstEvents.map((item, idx) => (
                                                            <tr key={idx}>
                                                               <td>
                                                                  <span className="news-events">
                                                                     <span className="news-title">{item?.EventTitle}</span>
                                                                     <span className="news-date">{formatDateGMT7(item?.ExecutionDate)}</span>
                                                                  </span>
                                                               </td>
                                                               <td className="news-detail">
                                                                  <span className="news-content" dangerouslySetInnerHTML={{ __html: item?.EventDetail }}>
                                                                     {/* {item?.EventDetail} */}
                                                                  </span>
                                                               </td>
                                                            </tr>
                                                         ))}
                                                   </tbody>
                                                </table>
                                             </div>
                                          </TabPanel>

                                          <TabPanel>
                                             <StockCharBarDetail code={stockInfo.code} />
                                          </TabPanel>
                                       </Tabs>
                                    </div>
                                 </div>
                              )}
                           </TabPanel>
                           <TabPanel style={{ flex: 1 }}>
                              <IndustryIndexNormalViewTable industryCode={groupSymbol?.code} groupSymbol={groupSymbol} inforBasic={inforBasic} />
                              {isMobile ? (
                                 <AutoSizer>
                                    {({ height, width }) => {
                                       return (
                                          <div style={{ height: height, width: width }}>
                                             <div className="scroll-styled">
                                                <div>
                                                   {chartType !== "D" ? (
                                                      <CandleStickHistChart code={stockInfo.code} type="ST" chartType={chartType} style={{ height: "250px" }} />
                                                   ) : (
                                                      <StockCandleStickIndayChart code={stockInfo.code} style={{ height: "250px" }} />
                                                   )}
                                                </div>
                                                <div className={"text-center listoption"} style={{ paddingTop: 10, paddingBottom: 20 }}>
                                                   <button className={chartType === "D" ? "active" : ""} onClick={() => _handleChangeChartType("D")} onTouchStart={() => _handleChangeChartType("D")}>
                                                      {t("homNay")}
                                                   </button>
                                                   <button className={chartType === "W" ? "active" : ""} onClick={() => _handleChangeChartType("W")} onTouchStart={() => _handleChangeChartType("W")}>
                                                      1 {t("tuan")}
                                                   </button>
                                                   <button
                                                      className={chartType === "1M" ? "active" : ""}
                                                      onClick={() => _handleChangeChartType("1M")}
                                                      onTouchStart={() => _handleChangeChartType("1M")}
                                                   >
                                                      1 {t("thang")}
                                                   </button>
                                                   {/* <button
                                    className={chartType === "3M" ? "active" : ""}
                                    onClick={() => _handleChangeChartType("3M")}
                                    onTouchStart={() => _handleChangeChartType("3M")}
                                  >
                                    3 {t("thang")}
                                  </button>
                                  <button
                                    className={chartType === "6M" ? "active" : ""}
                                    onClick={() => _handleChangeChartType("6M")}
                                    onTouchStart={() => _handleChangeChartType("6M")}
                                  >
                                    6 {t("thang")}
                                  </button>
                                  <button
                                    className={chartType === "1Y" ? "active" : ""}
                                    onClick={() => _handleChangeChartType("1Y")}
                                    onTouchStart={() => _handleChangeChartType("1Y")}
                                  >
                                    1 {t("nam")}
                                  </button>
                                  <button
                                    className={chartType === "5Y" ? "active" : ""}
                                    onClick={() => _handleChangeChartType("5Y")}
                                    onTouchStart={() => _handleChangeChartType("5Y")}
                                  >
                                    5 {t("nam")}
                                  </button> */}
                                                </div>

                                                <StockDetail counter={stockInfo.counter} code={stockInfo.code} stockInfo={stockInfo} />
                                                <div className="titletabs">{t("mucGia")}</div>
                                                <StockPriceChart style={{ height: "200px" }} code={stockInfo.code} floorPrice={c_floorPrice} refPrice={c_refPrice} ceilPrice={c_ceilPrice} />
                                             </div>
                                          </div>
                                       );
                                    }}
                                 </AutoSizer>
                              ) : (
                                 <div
                                    style={{
                                       display: "flex",
                                       height: "calc(100% - 67px)",
                                       width: "100%",
                                       position: "relative",
                                       gap: "15px",
                                    }}
                                 >
                                    <div style={{ height: "100%", display: "flex", flexDirection: "column", flex: 1 }}>
                                       <iframe
                                          style={{ height: "100%", width: "100%", border: "unset" }}
                                          src={constHostAddressConfig.ApiTVSIAddress + "chart?" + `symbol=${stockInfo.code}&language=${language}&p_username=${userName}`}
                                          title=""
                                       ></iframe>
                                    </div>
                                    <div className="boxinfo--right" style={{ width: "40%" }}>
                                       <Tabs>
                                          <TabList className="mb-1">
                                             <Tab>{t("lichSuKL")}</Tab>
                                             <Tab>{t("suKien")}</Tab>
                                             <Tab>{t("bieuDoKhopLenhTheoBuocGia")}</Tab>
                                          </TabList>
                                          <TabPanel>
                                             <AutoSizer>
                                                {({ height, width }) => {
                                                   return (
                                                      <div className="tbl__popup" style={{ height: height, width: width }}>
                                                         <div className="tab-body-right d-flex flex-column" style={{ height: height }}>
                                                            <StockMatchDetailV2
                                                               style={{ height: "100%", flex: 1 }}
                                                               code={stockInfo.code}
                                                               refPrice={stockInfo.refPrice}
                                                               floorPrice={stockInfo.floorPrice}
                                                               ceilPrice={stockInfo.ceilPrice}
                                                            />
                                                         </div>
                                                      </div>
                                                   );
                                                }}
                                             </AutoSizer>
                                          </TabPanel>
                                          <TabPanel>
                                             <div className="scrollTable tabs-content">
                                                <table className="tb-popup-detail">
                                                   <thead>
                                                      <tr>
                                                         <th>Sự kiện</th>
                                                         <th>Chi tiết</th>
                                                      </tr>
                                                   </thead>
                                                   <tbody>
                                                      {lstEvents &&
                                                         lstEvents.length > 0 &&
                                                         lstEvents.map((item, idx) => (
                                                            <tr key={idx}>
                                                               <td>
                                                                  <span className="news-events">
                                                                     <span className="news-title">{item?.EventTitle}</span>
                                                                     <span className="news-date">{item?.ExecutionDate}</span>
                                                                  </span>
                                                               </td>
                                                               <td className="news-detail">
                                                                  <span className="news-content" dangerouslySetInnerHTML={{ __html: item?.EventDetail }}>
                                                                     {/* {item?.EventDetail} */}
                                                                  </span>
                                                               </td>
                                                            </tr>
                                                         ))}
                                                   </tbody>
                                                </table>
                                             </div>
                                          </TabPanel>
                                          <TabPanel>
                                             <StockCharBarDetail code={stockInfo.code} />
                                          </TabPanel>
                                       </Tabs>
                                    </div>
                                 </div>
                              )}
                           </TabPanel>
                        </Tabs>
                     ) : popupConfig.type === "IND" ? (
                        <Tabs style={{ display: "flex", flexDirection: "column" }}>
                           <TabList>
                              <Tab>{t("tongQuan")}</Tab>
                              <Tab>{t("dsChungKhoan")}</Tab>
                           </TabList>
                           <TabPanel style={{ flex: 1 }}>
                              <IndustryIndexDetail industryCode={popupConfig.code} />
                           </TabPanel>
                           <TabPanel style={{ flex: 1, padding: 8 }}>
                              <IndustryTop industryCode={popupConfig.code} />
                           </TabPanel>
                        </Tabs>
                     ) : popupConfig.type === "IDX" ? (
                        <IDXPopupContent indexCode={indexInfo?.indexCode} priorIndex={priceToNumber(indexInfo?.priorIndex)} />
                     ) : (
                        <></>
                     )}
                  </div>
               </div>
            </div>
         </Draggable>
      </div>
   ) : (
      <></>
   );
}
//
const StockIndustry = memo(function (props) {
   const { code, industryCode } = props;
   //
   const { t } = useTranslation();
   //
   const [tabActive, setTabActive] = useState(0);
   //
   return (
      <>
         {industryCode && industryCode !== "" ? (
            <div className="dflex-vertical">
               <div className="btn__nn">
                  <button className={tabActive === 0 ? "active" : ""} onClick={() => setTabActive(0)}>
                     {t("tongQuan")}
                  </button>
                  <button className={tabActive === 1 ? "active" : ""} onClick={() => setTabActive(1)}>
                     {t("viTri")}
                  </button>
               </div>
               <div className="tbl__popup" style={{ flex: 1, padding: 8 }}>
                  {tabActive === 0 ? <IndustryIndexDetail industryCode={industryCode} /> : tabActive === 1 ? <IndustryTop symbolOnTop={code} industryCode={industryCode} /> : <></>}
               </div>
            </div>
         ) : null}
      </>
   );
});
